import type { SubscriptionInterval } from '../types/CheckoutType';
import type { CheckoutUrlRootBuilder } from './CheckoutUrlRootBuilder';

/** Platform SaaS subscription — scoped to the authenticated creator (no creator param). */
export class PlatformSubscriptionIntentBuilder {
  constructor(private readonly root: CheckoutUrlRootBuilder) {}

  /** The SaaS plan slug (`SubscriptionPlan.productSlug`); carried as `plan`. */
  plan(productSlug: string): this {
    this.root.param('plan', productSlug);
    return this;
  }

  interval(interval: SubscriptionInterval): this {
    this.root.param('interval', interval);
    return this;
  }

  /**
   * Opt into the plan's PAID trial (`use_paid_trial`) — today the creator pays the
   * trial fee, then full price recurring. Only takes effect when the plan offers one.
   */
  paidTrial(use = true): this {
    this.root.param('use_paid_trial', use ? '1' : undefined);
    return this;
  }
}
